import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import TgProgress from 'Components/Common/TgProgress';
import { INTEGRATIONS_API_BASE_URL } from 'state/constants/api';

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    margin: 0,
    backgroundColor: theme.palette.primary.main,
  },
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  loginBox: {
    margin: 'auto',
    width: '400px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      margin: theme.spacing(2),
    },
  },
  logo: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
  },
  button: {
    width: '100%',
  },
  subtitle: {
    color: theme.palette.primary[500],
    marginBottom: theme.spacing(3),
  },
  errorsubtitle: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(3),
  },
  card: {
    padding: theme.spacing(5),
    '&:last-child': {
      paddingBottom: theme.spacing(6),
    },
  },
});

class Bind extends Component {
  state = {
    status: 'pending',
    hasParams: false,
  };

  componentDidMount() {
    const { tenantID, accessToken, name } = this.props;
    const parsedQs = queryString.parse(window.location.search);
    let { hasParams } = this.state;

    if (name === 'tenant') {
      hasParams = !!parsedQs.serviceName && !!parsedQs.id;
    } else if (name === 'identity') {
      hasParams = !!(parsedQs.serviceName && !!parsedQs.id && !!parsedQs.nonce);
    }

    if (hasParams) {
      // ugly and hacky but works for now
      this.setState({
        hasParams: true,
      });

      const requestID = nanoid(10);
      const headers = { headers: { Authorization: `Bearer ${accessToken}` } };

      let payload;
      if (this.props.name === 'tenant') {
        payload = { serviceName: parsedQs.serviceName, aad_tenant_id: parsedQs.id, requestID };
      } else if (this.props.name === 'identity') {
        payload = {
          serviceName: parsedQs.serviceName,
          im_user_id: parsedQs.id,
          nonce: parsedQs.nonce,
          requestID,
        };
      }
      axios
        .post(`${INTEGRATIONS_API_BASE_URL}/${tenantID}/bind${name}`, payload, headers)
        .then(() => {
          this.setState({
            status: 'done',
          });
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log('Caught error: ', error);
          this.setState({
            status: 'error',
          });
        });
    }
  }

  render() {
    const { t, classes, name } = this.props;
    const { hasParams, status } = this.state;

    return (
      <div className={classes.root} id="content">
        <div className={classes.wrapper}>
          <div className={classes.loginBox}>
            <Card elevation={24}>
              <CardContent className={classes.card}>
                <img
                  src="data:image/png;base64,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"
                  width={249}
                  height={29}
                  alt="Tangible Growth"
                  className={classes.logo}
                />
                {hasParams ? (
                  <React.Fragment>
                    {status === 'pending' && (
                      <React.Fragment>
                        <Typography variant="subtitle2" className={classes.subtitle}>
                          {t(`binding.${name}.title`)}
                        </Typography>
                        <TgProgress />
                      </React.Fragment>
                    )}

                    {status === 'done' && (
                      <React.Fragment>
                        <Typography variant="subtitle2" className={classes.subtitle}>
                          {`${t('general.done')}! 🎉`}
                        </Typography>
                        <Button
                          component={Link}
                          to="/home"
                          name="bind-account-return-home"
                          className={classes.button}
                          variant="contained"
                          color="secondary"
                        >
                          {t('general.continue')}
                        </Button>
                      </React.Fragment>
                    )}

                    {status === 'error' && (
                      <React.Fragment>
                        <Typography variant="subtitle2" className={classes.errorsubtitle}>
                          {t('general.oops')}
                        </Typography>
                        <Button
                          component={Link}
                          to="/home"
                          name={`bind-${name}-return-home`}
                          className={classes.button}
                          variant="contained"
                          color="secondary"
                        >
                          {t('general.continue')}
                        </Button>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography variant="subtitle2" className={classes.errorsubtitle}>
                      {t(`binding.${name}.errorCouldNotBind`)}
                    </Typography>
                    <br />
                    <Button
                      component={Link}
                      to="/home"
                      name={`bind-${name}-return-home`}
                      className={classes.button}
                      variant="contained"
                      color="secondary"
                    >
                      {t('general.goHomeCta')}
                    </Button>
                  </React.Fragment>
                )}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

Bind.propTypes = {
  classes: PropTypes.exact({
    root: PropTypes.string,
    wrapper: PropTypes.string,
    loginBox: PropTypes.string,
    card: PropTypes.string,
    logo: PropTypes.string,
    subtitle: PropTypes.string,
    button: PropTypes.string,
    errorsubtitle: PropTypes.string,
  }),
  tenantID: PropTypes.string,
  accessToken: PropTypes.string,
  name: PropTypes.string,
  t: PropTypes.func,
};

const mapStateToProps = state => ({
  tenantID: state.auth.tenantID,
  accessToken: state.auth.tokens.access_token,
});

export default withTranslation()(connect(mapStateToProps)(withStyles(styles)(Bind)));
